import { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import {
  Perm_Advance_View,
  Perm_CarCompany_View,
  Perm_CarType_View,
  Perm_Currency_View,
  Perm_Customer_Add,
  Perm_Customer_View,
  Perm_Drive_View,
  Perm_GenusHistory_View,
  Perm_Location_View,
  Perm_OfferToPay_View,
  Perm_Order_Add,
  Perm_Order_Edit,
  Perm_Order_Menu_View,
  Perm_Order_Menu_View_Kt,
  Perm_Order_Report_Kt,
  Perm_Order_TransportCoordination_View,
  Perm_Order_View,
  Perm_OrderType_View,
  Perm_PaymentMethod_View,
  Perm_PriceBase_View,
  Perm_Reimburse_View,
  Perm_RequestOrder_View,
  Perm_ShellType_View,
  Perm_Shipment_View,
  Perm_ShippingLine_View,
  Perm_Staff_View,
  Perm_StaffType_View,
  Perm_Standard_View
} from '../app/hooks/premissionScreen'
import MainLayout from '../components/layout/MainLayout'
import Loadable from '../components/ui-component/Loadable'
import { PERMISSION } from '../constants'
import NotAuthorizedPage from '../page/notAuthor/NotAuthorizedPage'
import ROUTES from './helpersRouter/constantRouter'
import { createPrivateRoute, createProtectedRoute } from './helpersRouter/routeHelpers'

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('../page/dashboard/DashboardPage')))

// admin routing
// const AdminPage = Loadable(lazy(() => import('../page/admin/AdminPage')))

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('../page/utilities/Typography')))
const UtilsColor = Loadable(lazy(() => import('../page/utilities/Color')))
const UtilsShadow = Loadable(lazy(() => import('../page/utilities/Shadow')))
const UtilsInput = Loadable(lazy(() => import('../page/utilities/Input')))
const SamplePage = Loadable(lazy(() => import('../page/home/HomePage')))
const StaffPage = Loadable(lazy(() => import('../page/category/staff')))
// const StaffDetailPage = Loadable(lazy(() => import('../page/category/staff/detail')))
// const PartnerPage = Loadable(lazy(() => import('../page/category/partner')))
// const CompanyPage = Loadable(lazy(() => import('../page/category/company')))
//Xe công ty
const CompanyCarPage = Loadable(lazy(() => import('../page/companyCar')))
const DetailCompanyCarPage = Loadable(lazy(() => import('../page/companyCar/detail')))
//Lái xe
const DriverPage = Loadable(lazy(() => import('../page/driver')))
const DetailDriverPage = Loadable(lazy(() => import('../page/driver/detail')))
//
const ShellTypePage = Loadable(lazy(() => import('../page/category/shellType')))
const CarTypePage = Loadable(lazy(() => import('../page/category/carType')))
const ShippingLinesPage = Loadable(lazy(() => import('../page/category/shippingLines')))
const PaymentMethodPage = Loadable(lazy(() => import('../page/category/paymentMethod')))
const CurrencyPage = Loadable(lazy(() => import('../page/category/currency')))
const OrderTPage = Loadable(lazy(() => import('../page/category/orderType')))
const StaffTypePage = Loadable(lazy(() => import('../page/category/staffType')))
const LocationPage = Loadable(lazy(() => import('../page/category/location')))
const CustomerPage = Loadable(lazy(() => import('../page/category/customer')))
const DetailCustomerPage = Loadable(lazy(() => import('../page/category/customer/detail')))
const AddCustomerPage = Loadable(lazy(() => import('../page/category/customer/add/AddCustomer')))

//Salary
// const SalaryAdvancePage = Loadable(lazy(() => import('../page/category/salary/salary_advance')))
// const SalaryPayPage = Loadable(lazy(() => import('../page/category/salary/salary-pay')))

//Order
const RequestOrderPage = Loadable(lazy(() => import('../page/order/requestOrder')))
const PriceBasePage = Loadable(lazy(() => import('../page/order/priceBase')))

//Lịch sử chi
const CostOliPage = Loadable(lazy(() => import('../page/genusHistory/costOil')))
const CostGeneralPage = Loadable(lazy(() => import('../page/genusHistory/costGeneral')))
const CostRepairPage = Loadable(lazy(() => import('../page/genusHistory/costRepair')))
const CostRoadPage = Loadable(lazy(() => import('../page/genusHistory/costRoad')))
const CostBonusPage = Loadable(lazy(() => import('../page/genusHistory/costBonus')))

//Định mức
const NormsSalaryMonthPage = Loadable(lazy(() => import('../page/norms/normsSalaryMonth')))
const NormSalaryOrderPage = Loadable(lazy(() => import('../page/norms/normSalaryOrder')))
const NormsDegradationPage = Loadable(lazy(() => import('../page/norms/normsDegradation')))

//Đơn hàng
const ListOrderPage = Loadable(lazy(() => import('../page/order/list')))
const ListOrderKtPage = Loadable(lazy(() => import('../page/order/listKT')))
const AddOrderNewFastPage = Loadable(lazy(() => import('../page/order/addOrderFast')))
const AddNewOrderPage = Loadable(lazy(() => import('../page/order/addNewOrder')))
const DetailOrderInfoPage = Loadable(lazy(() => import('../page/order/detailOrder')))
const DetailOrderInfoKtPage = Loadable(lazy(() => import('../page/order/detailOrderKT')))

//Lô hàng
const ListShipmentPage = Loadable(lazy(() => import('../page/order/shipment')))
const ListShipmentKtPage = Loadable(lazy(() => import('../page/order/listShipmentKT')))
const DetailShipmentInfoPage = Loadable(lazy(() => import('../page/order/shipment/detail')))
const DetailShipmentKtInfoPage = Loadable(lazy(() => import('../page/order/detailShipmentKT')))

//Điều phối
const ListTransportCoordinationPage = Loadable(lazy(() => import('../page/transportCoordination')))
const MaintenanceSchedulePage = Loadable(lazy(() => import('../page/transportCoordination/maintenanceSchedule')))
const VacationSchedulePage = Loadable(lazy(() => import('../page/transportCoordination/vacationSchedule')))
const RegistrationInspectionSchedulePage = Loadable(
  lazy(() => import('../page/transportCoordination/registrationInspectionSchedule'))
)

//Report
const AdvancePage = Loadable(lazy(() => import('../page/report/advance')))
const AddEditPreviewAdvancePage = Loadable(lazy(() => import('../page/report/advance/addEdit')))
const OfferToPayPage = Loadable(lazy(() => import('../page/report/offerToPay')))
const AddEditPreviewOfferToPayPage = Loadable(lazy(() => import('../page/report/offerToPay/addEdit')))
const Reimburse = Loadable(lazy(() => import('../page/report/reimburse')))
const AddEditPreviewReimburse = Loadable(lazy(() => import('../page/report/reimburse/addEdit')))
const ReportKtPage = Loadable(lazy(() => import('../page/reportKT')))
const ChecklistPage = Loadable(lazy(() => import('../page/logisticsChecklist')))
const LogisticsCheckListDetail = Loadable(lazy(() => import('../page/logisticsChecklist/LogisticsCheckListDetail')))
const ProfitReportPage = Loadable(lazy(() => import('../page/report/profit')))
const CashBookPage = Loadable(lazy(() => import('../page/finance/cashBook')))
const CustomerDebtPage = Loadable(lazy(() => import('../page/finance/customerDebt')))
const AnalyticsPage = Loadable(lazy(() => import('../page/report/analytics')))

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: ROUTES.HOME,
  element: createPrivateRoute(<MainLayout />),
  children: [
    {
      path: ROUTES.STATISTICAL_CHILD.REQUEST,
      children: [
        {
          path: ROUTES.INDEX,
          element: <DashboardDefault />
        }
      ]
    },
    // {
    //   path: ROUTES.ORDER,
    //   children: [
    //     {
    //       path: ROUTES.DEFAULT,
    //       element: <AdminPage />
    //     },
    //     {
    //       path: ROUTES.ORDER_DETAIL,
    //       element: <StaffPage />
    //     }
    //   ]
    // },
    {
      path: ROUTES.STATISTICAL,
      children: [
        {
          path: ROUTES.STATISTICAL_CHILD.REQUEST,
          element: createProtectedRoute(<RequestOrderPage />, Perm_RequestOrder_View)
        },
        {
          path: ROUTES.STATISTICAL_CHILD.BASE_PRICE,
          element: createProtectedRoute(<PriceBasePage />, Perm_PriceBase_View)
        }
      ]
    },
    {
      path: ROUTES.CUSTOMER,
      children: [
        {
          path: ROUTES.INDEX,
          element: createProtectedRoute(<CustomerPage />, Perm_Customer_View)
        },
        {
          path: ROUTES.CUSTOMER_ADD,
          element: createProtectedRoute(<AddCustomerPage />, Perm_Customer_Add)
        },
        {
          path: ROUTES.CUSTOMER_DETAIL_ID,
          element: createProtectedRoute(<DetailCustomerPage />, Perm_Customer_View)
        }
      ]
    },
    {
      path: ROUTES.STAFF,
      children: [
        {
          path: ROUTES.INDEX,
          element: createProtectedRoute(<StaffPage />, Perm_Staff_View)
        }
      ]
    },
    {
      path: ROUTES.COMPANY,
      children: [
        {
          path: ROUTES.COMPANY_CHILD.CAR,
          element: createProtectedRoute(<CompanyCarPage />, Perm_CarCompany_View)
        },
        {
          path: ROUTES.COMPANY_CHILD.CAR_DETAIL,
          element: createProtectedRoute(<DetailCompanyCarPage />, Perm_CarCompany_View)
        },
        {
          path: ROUTES.COMPANY_CHILD.DRIVER,
          element: createProtectedRoute(<DriverPage />, Perm_Drive_View)
        },
        {
          path: ROUTES.COMPANY_CHILD.DRIVER_DETAIL,
          element: createProtectedRoute(<DetailDriverPage />, Perm_Drive_View)
        },
        {
          path: ROUTES.COMPANY_CHILD.COST_OLI,
          element: createProtectedRoute(<CostOliPage />, Perm_GenusHistory_View)
        },
        {
          path: ROUTES.COMPANY_CHILD.COST_REPAIR,
          element: createProtectedRoute(<CostRepairPage />, Perm_GenusHistory_View)
        },
        {
          path: ROUTES.COMPANY_CHILD.COST_GENERAL,
          element: createProtectedRoute(<CostGeneralPage />, Perm_GenusHistory_View)
        },
        {
          path: ROUTES.COMPANY_CHILD.COST_ROAD,
          element: createProtectedRoute(<CostRoadPage />, Perm_GenusHistory_View)
        },
        {
          path: ROUTES.COMPANY_CHILD.COST_BONUS,
          element: createProtectedRoute(<CostBonusPage />, Perm_GenusHistory_View)
        },
        {
          path: ROUTES.COMPANY_CHILD.NORMS_SALARY_MONTH,
          element: createProtectedRoute(<NormsSalaryMonthPage />, Perm_Standard_View)
        },
        {
          path: ROUTES.COMPANY_CHILD.NORMS_SALARY_ORDERS,
          element: createProtectedRoute(<NormSalaryOrderPage />, Perm_Standard_View)
        },
        {
          path: ROUTES.COMPANY_CHILD.NORMS_DEGRADATION,
          element: createProtectedRoute(<NormsDegradationPage />, Perm_Standard_View)
        }
      ]
    },
    {
      path: ROUTES.UTILS,
      children: [
        {
          path: ROUTES.UTILS_CHILD.TYPOGRAPHY,
          element: <UtilsTypography />
        },
        {
          path: ROUTES.UTILS_CHILD.SHADOW,
          element: <UtilsShadow />
        },
        {
          path: ROUTES.UTILS_CHILD.COLOR,
          element: <UtilsColor />
        },
        {
          path: ROUTES.UTILS_CHILD.INPUT,
          element: <UtilsInput />
        }
      ]
    },
    {
      path: ROUTES.CATEGORY,
      children: [
        // {
        //   path: ROUTES.CATEGORY_CHILD.STAFF,
        //   element: createProtectedRoute(<StaffPage />, [PERMISSION.ADMIN])
        // },
        // {
        //   path: ROUTES.CATEGORY_CHILD.STAFF_DETAIL,
        //   // element: <StaffDetailPage />,
        //   element: createProtectedRoute(<StaffDetailPage />, [
        //     PERMISSION.ADMIN,
        //     PERMISSION.GIAMDOC,
        //     PERMISSION.KETOAN,
        //     PERMISSION.SALE,
        //     PERMISSION.HCNS,
        //     PERMISSION.TUYENDUNG
        //   ])
        // },
        // {
        //   path: ROUTES.CATEGORY_CHILD.PARTER,
        //   element: createProtectedRoute(<PartnerPage />, [PERMISSION.ADMIN])
        // },
        // {
        //   path: ROUTES.CATEGORY_CHILD.COMPANY,
        //   element: createProtectedRoute(<CompanyPage />, [PERMISSION.ADMIN])
        // },
        {
          path: ROUTES.CATEGORY_CHILD.SHELL_TYPE,
          element: createProtectedRoute(<ShellTypePage />, Perm_ShellType_View)
        },
        {
          path: ROUTES.CATEGORY_CHILD.CAR_TYPE,
          element: createProtectedRoute(<CarTypePage />, Perm_CarType_View)
        },
        {
          path: ROUTES.CATEGORY_CHILD.SHIPPING_LINES,
          element: createProtectedRoute(<ShippingLinesPage />, Perm_ShippingLine_View)
        },
        {
          path: ROUTES.CATEGORY_CHILD.CURRENCY,
          element: createProtectedRoute(<CurrencyPage />, Perm_Currency_View)
        },
        {
          path: ROUTES.CATEGORY_CHILD.ORDER_TYPE,
          element: createProtectedRoute(<OrderTPage />, Perm_OrderType_View)
        },
        {
          path: ROUTES.CATEGORY_CHILD.STAFF_TYPE,
          element: createProtectedRoute(<StaffTypePage />, Perm_StaffType_View)
        },
        {
          path: ROUTES.CATEGORY_CHILD.PAYMENT_METHOD,
          element: createProtectedRoute(<PaymentMethodPage />, Perm_PaymentMethod_View)
        },
        {
          path: ROUTES.CATEGORY_CHILD.LOCATION,
          element: createProtectedRoute(<LocationPage />, Perm_Location_View)
        }
        // {
        //   path: ROUTES.CATEGORY_CHILD.SALARY_ADVANCE,
        //   // element: <SalaryAdvancePage />
        //   element: createProtectedRoute(<SalaryAdvancePage />, [
        //     PERMISSION.ADMIN,
        //     PERMISSION.GIAMDOC,
        //     PERMISSION.KETOAN,
        //     PERMISSION.SALE,
        //     PERMISSION.TUYENDUNG
        //   ])
        // },
        // {
        //   path: ROUTES.CATEGORY_CHILD.SALARY_PAY_STAFF,
        //   // element: <SalaryPayPage type='STAFF' />,
        //   element: createProtectedRoute(<SalaryPayPage type='STAFF' />, [
        //     PERMISSION.ADMIN,
        //     PERMISSION.GIAMDOC,
        //     PERMISSION.KETOAN
        //   ])
        // }
      ]
    },
    {
      path: ROUTES.ORDER,
      children: [
        {
          path: ROUTES.ORDER_CHILD.ORDER_LIST,
          element: createProtectedRoute(<ListOrderPage />, Perm_Order_Menu_View)
        },
        {
          path: ROUTES.ORDER_CHILD.ORDER_LIST_KT,
          element: createProtectedRoute(<ListOrderKtPage />, Perm_Order_Menu_View_Kt)
        },
        {
          path: ROUTES.ORDER_CHILD.ORDER_ORDER_NEW,
          element: createProtectedRoute(<AddNewOrderPage />, Perm_Order_Add)
        },
        {
          path: ROUTES.ORDER_CHILD.ORDER_DETAIL_ID,
          element: createProtectedRoute(<DetailOrderInfoPage />, Perm_Order_View)
        },
        {
          path: ROUTES.ORDER_CHILD.ORDER_DETAIL_KT_ID,
          element: createProtectedRoute(<DetailOrderInfoKtPage />, Perm_Order_Menu_View_Kt)
        },
        {
          path: ROUTES.ORDER_CHILD.ORDER_UPDATE_ID,
          element: createProtectedRoute(<AddNewOrderPage />, Perm_Order_Edit)
        },
        {
          path: ROUTES.ORDER_CHILD.ORDER_CONNECT_ID,
          element: createProtectedRoute(<AddNewOrderPage />, Perm_Order_Add)
        },
        {
          path: ROUTES.ORDER_CHILD.ORDER_ORDER_FAST,
          element: createProtectedRoute(<AddOrderNewFastPage />, Perm_Order_View)
        },
        {
          path: ROUTES.ORDER_CHILD.ORDER_SHIPMENT,
          element: createProtectedRoute(<ListShipmentPage />, Perm_Shipment_View)
        },
        {
          path: ROUTES.ORDER_CHILD.ORDER_SHIPMENT_KT,
          element: createProtectedRoute(<ListShipmentKtPage />, Perm_Order_Menu_View_Kt)
        },
        {
          path: ROUTES.ORDER_CHILD.ORDER_SHIPMENT_DETAIL_ID,
          element: createProtectedRoute(<DetailShipmentInfoPage />, Perm_Shipment_View)
        },
        {
          path: ROUTES.ORDER_CHILD.ORDER_SHIPMENT_DETAIL_KT_ID,
          element: createProtectedRoute(<DetailShipmentKtInfoPage />, Perm_Order_Menu_View_Kt)
        },
        {
          path: ROUTES.ORDER_CHILD.ORDER_SHIPMENT_ADD_ORDER_ID,
          element: createProtectedRoute(<AddNewOrderPage />, Perm_Order_Add)
        },
        {
          path: ROUTES.ORDER_CHILD.ORDER_TRANSPORTCOORDINATION,
          element: createProtectedRoute(<ListTransportCoordinationPage />, Perm_Order_TransportCoordination_View)
        },
        {
          path: ROUTES.ORDER_CHILD.ORDER_TRANSPORTCOORDINATION_UPDATE_ID,
          element: createProtectedRoute(<AddNewOrderPage isTransportCoordiantion={true} />, Perm_Order_Edit)
        },
        {
          path: ROUTES.ORDER_CHILD.ORDER_MAINTENANCE_SCHEDULE, //Lịch bảo dưỡng
          element: createProtectedRoute(<MaintenanceSchedulePage />, Perm_Order_TransportCoordination_View)
        },
        {
          path: ROUTES.ORDER_CHILD.ORDER_REGISTRATIONINSPECTION_SCHEDULE, //Đăng ký đăng kiểm
          element: createProtectedRoute(<RegistrationInspectionSchedulePage />, Perm_Order_TransportCoordination_View)
        },
        {
          path: ROUTES.ORDER_CHILD.ORDER_VACATION_SCHEDULE, //Lịch nghỉ
          element: createProtectedRoute(<VacationSchedulePage />, Perm_Order_TransportCoordination_View)
        }
      ]
    },
    {
      path: ROUTES.REPORT,
      children: [
        {
          path: ROUTES.REPORT_CHILD.REPORT_KT,
          element: createProtectedRoute(<ReportKtPage />, Perm_Order_Report_Kt)
        },
        {
          path: ROUTES.REPORT_CHILD.REPORT_CHECK_LIST,
          element: createProtectedRoute(<ChecklistPage />, Perm_Order_Report_Kt)
        },
        {
          path: ROUTES.REPORT_CHILD.REPORT_CHECK_LIST_DETAIL_ID,
          element: createProtectedRoute(<LogisticsCheckListDetail />, Perm_Order_Report_Kt)
        },
        {
          path: ROUTES.REPORT_CHILD.PROFIT_REPORT,
          element: createProtectedRoute(<ProfitReportPage />, Perm_Order_Report_Kt)
        },
        {
          path: ROUTES.REPORT_CHILD.ANALYTICS,
          element: createProtectedRoute(<AnalyticsPage />, Perm_Order_Report_Kt)
        }
      ]
    },
    {
      path: ROUTES.FINANCE,
      children: [
        {
          path: ROUTES.FINANCE_CHILD.ADVANCE,
          element: createProtectedRoute(<AdvancePage />, Perm_Advance_View)
        },
        {
          path: ROUTES.FINANCE_CHILD.ADVANCE_DETAIL_ID,
          element: createProtectedRoute(<AddEditPreviewAdvancePage />, Perm_Advance_View)
        },
        {
          path: ROUTES.FINANCE_CHILD.ADD_ADVANCE_NEW,
          element: createProtectedRoute(<AddEditPreviewAdvancePage />, Perm_Advance_View)
        },
        {
          path: ROUTES.FINANCE_CHILD.OFFER_TO_PAY,
          element: createProtectedRoute(<OfferToPayPage />, Perm_OfferToPay_View)
        },
        {
          path: ROUTES.FINANCE_CHILD.OFFER_TO_PAY_DETAIL_ID,
          element: createProtectedRoute(<AddEditPreviewOfferToPayPage />, Perm_OfferToPay_View)
        },
        {
          path: ROUTES.FINANCE_CHILD.ADD_OFFER_TO_PAY_NEW,
          element: createProtectedRoute(<AddEditPreviewOfferToPayPage />, Perm_OfferToPay_View)
        },
        {
          path: ROUTES.FINANCE_CHILD.REIMBURSE,
          element: createProtectedRoute(<Reimburse />, Perm_Reimburse_View)
        },
        {
          path: ROUTES.FINANCE_CHILD.REIMBURSE_DETAIL_ID,
          element: createProtectedRoute(<AddEditPreviewReimburse />, Perm_Reimburse_View)
        },
        {
          path: ROUTES.FINANCE_CHILD.ADD_REIMBURSE_NEW,
          element: createProtectedRoute(<AddEditPreviewReimburse />, Perm_Reimburse_View)
        },
        {
          path: ROUTES.FINANCE_CHILD.CASH_BOOK,
          element: createProtectedRoute(<CashBookPage />, Perm_Order_Report_Kt)
        },
        {
          path: ROUTES.FINANCE_CHILD.CUSTOMER_DEBT,
          element: createProtectedRoute(<CustomerDebtPage />, Perm_Order_Report_Kt)
        }
      ]
    },
    // Redirects for legacy notification links
    { path: '/report/offer-to-pay', element: <Navigate to="/finance/offer-to-pay" replace /> },
    { path: '/report/advance', element: <Navigate to="/finance/advance" replace /> },
    { path: '/report/advance-payment', element: <Navigate to="/finance/advance" replace /> },
    { path: '/report/reimburse', element: <Navigate to="/finance/reimburse" replace /> },
    {
      path: ROUTES.SAMPLE_PAGE,
      element: createProtectedRoute(<SamplePage />, [PERMISSION.SALE])
    },
    {
      path: ROUTES.NOT_AUTHORIZED,
      element: <NotAuthorizedPage />
    }
  ]
}

export default MainRoutes
